module.exports = "<style>\r\n    .imageLoader{\r\n        display: none;\r\n    }\r\n</style>\r\n<div>\r\n\r\n</div>\r\n\r\n<div style=\"margin:auto;\">\r\n    \r\n<canvas #myCanvas style=\"margin:auto;\" >\r\n\r\n</canvas>\r\n\r\n<loading-component #myLoading></loading-component>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/xamppabeel/htdocs/Angular2Projects/CanvasSVG/src/app/common/canvas.template.html
// module id = ../../../../../src/app/common/canvas.template.html
// module chunks = main